import { Directive, Input, OnDestroy, OnInit, TemplateRef, ViewContainerRef } from '@angular/core';
import { ClaimService } from '../services/claim/claim.service';
import { forLifeOf, LifecycleAware } from '../utilities/rxjs.helpers';

@LifecycleAware()
@Directive({
    selector: '[claim]'
})
export class ClaimDirective implements OnDestroy, OnInit {
    @Input() public claim: number;
    @Input() public claimMissing?: TemplateRef<any>;
    private _hasEmbeddedView = false;

    constructor(
        public claimService: ClaimService,
        private _templateRef: TemplateRef<any>,
        private _viewContainerRef: ViewContainerRef
    ) {}

    public ngOnInit(): void {
        if (this.claim) {
            this.claimService
                .isOn(this.claim)
                .pipe(forLifeOf(this))
                .subscribe((claimIsOn) => {
                    if (claimIsOn) {
                        if (!this._hasEmbeddedView) {
                            this._viewContainerRef.createEmbeddedView(this._templateRef);
                            this._hasEmbeddedView = true;
                        }
                    } else {
                        this._viewContainerRef.clear();
                        this._hasEmbeddedView = false;

                        if (!!this.claimMissing) {
                            this._viewContainerRef.createEmbeddedView(this.claimMissing);
                            this._hasEmbeddedView = true;
                        }
                    }
                });
        } else if (!this._hasEmbeddedView) {
            this._viewContainerRef.createEmbeddedView(this._templateRef);
            this._hasEmbeddedView = true;
        }
    }

    public ngOnDestroy(): void {}
}
